import PropTypes from 'prop-types'

import './index.css'

const FormSectionComponent = ({ children, config={} }) => {
    return (
        <div className="c-FormSection">
            {config.title ? <h3 className="formSection-title">{config.title}</h3> : null}
            {children}
        </div>
    )
}

FormSectionComponent.propTypes = {
    children: PropTypes.any,

    config: PropTypes.shape({
        title: PropTypes.string
    })
}

export { FormSectionComponent }
